'use strict';
'use client';
import { useState as r, useEffect as s, useCallback as u } from "react";
function o() {
  const { innerWidth: n, innerHeight: e } = window;
  return {
    width: n,
    height: e
  };
}
function d() {
  const [n, e] = r({
    width: 0,
    height: 0
  });
  return s(() => {
    e(o());
  }, []), s(() => {
    function i() {
      e(o());
    }
    return window.addEventListener("resize", i), () => window.removeEventListener("resize", i);
  }, []), n;
}
function w() {
  const [n, e] = r(null), i = u((t) => {
    t !== null && e(t.getBoundingClientRect());
  }, []);
  return [n, i];
}
export {
  w as useClientRect,
  d as useWindowDimensions
};
